import React, { ReactElement } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from '../../../../../../node_module_clones/recompose';

import AiAssistantPopup from './popup/AiAssistantPopup';
import ToolbarPopupTool from '../../ToolbarPopupTool';
import TooltipSource from '../../../../../components/tooltips/TooltipSource';
import ToolbarErrorBoundary from '../../ToolbarErrorBoundary';
import AiAssistantToolIcon from './icon/AiAssistantToolIcon';

import useAiToolStateReducer from './state/useAiToolStateReducer';
import useSubmitAiStreamRequestHandlers from './state/useSubmitAiStreamRequestHandlers';
import useStreamPromptFollowups from './state/useStreamAiPromptFollowups';

import { getThemeIsDarkMode } from '../../../../../user/account/accountModal/interface/themeSettings/themeSelector';

import { TooltipPositions } from '../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import { TIMES } from '../../../../../../common/utils/timeUtil';
import { PromptShortcut } from '../../../../../../common/ai/aiPromptShortcutTypes';
import useFetchAiToolPromptShortcutsDecorator from './state/useFetchAiToolPromptShortcutsDecorator';

const aiToolSelector = createStructuredSelector({
    isDarkMode: getThemeIsDarkMode,
});

const connector = connect(aiToolSelector);

const enhance = compose(connector, useFetchAiToolPromptShortcutsDecorator);

type PropsFromRedux = ConnectedProps<typeof connector>;
interface AiAssistantToolProps extends PropsFromRedux {
    tooltipEnabled: boolean;
    currentUser: unknown;
    rootPromptShortcut: PromptShortcut;
}

const AiAssistantToolContent = (props: AiAssistantToolProps): ReactElement => {
    const { tooltipEnabled, rootPromptShortcut } = props;

    const toolState = useAiToolStateReducer(rootPromptShortcut);
    const streamRequestHandlers = useSubmitAiStreamRequestHandlers(toolState);
    useStreamPromptFollowups(toolState);

    return (
        <div className="AiAssistantTool">
            <TooltipSource
                tooltipText="Click me"
                position={TooltipPositions.RIGHT}
                distance={5}
                duration={TIMES.SECOND * 5}
                enabled={tooltipEnabled}
                fade
                triggerOnDrag
            >
                <ToolbarPopupTool
                    {...props}
                    {...toolState}
                    {...streamRequestHandlers}
                    distance={12}
                    name="AI Ideas"
                    toolName={PopupIds.AI_ASSISTANT}
                    PopupComponent={AiAssistantPopup}
                >
                    <AiAssistantToolIcon isAnimated />
                </ToolbarPopupTool>
            </TooltipSource>
        </div>
    );
};

const AiAssistantTool = (props: AiAssistantToolProps): ReactElement => (
    <ToolbarErrorBoundary>
        <AiAssistantToolContent {...props} />
    </ToolbarErrorBoundary>
);

// @ts-ignore Can't figure out how to make the compose function typesafe
export default enhance(AiAssistantTool);
